export const API_BASE_URL = "https://api.erotix.ai";
//export const API_BASE_URL = "http://localhost:3088";
export const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY ?? "";
export const ENCRYPTION_IV = process.env.REACT_APP_ENCRYPTION_IV ?? "";
export const USER_TOKEN_KEY = "USER_TOKEN";
export const USER_ID_KEY = "USER_ID";
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? "";